<template src="./templates/ResultsHeaderText.html" />

<script setup>

import { computed } from 'vue';
import {
    useCategoriesStore,
    useFacetsStore,
    useRegionsStore,
    useLocationsStore,
    useResultsStore,
    useQueryParamsStore,
    useClearFilters,
    useDatesStore,
} from '@timezoneone/dottie-client-jam';

const categoriesStore = useCategoriesStore();
const regionsStore = useRegionsStore();
const locationsStore = useLocationsStore();
const facetsStore = useFacetsStore();
const resultsStore = useResultsStore();
const queryParamsStore = useQueryParamsStore();
const datesStore = useDatesStore();

const activeFilters = computed(() => {

    const filters = [];

    const chosenCategories = categoriesStore.categories.filter((category) => category.checked);

    if (categoriesStore.chosenTopLevelCategory) {

        const topCategory = categoriesStore.topLevelCategories.find((category) => category.id === categoriesStore.chosenTopLevelCategory);

        if (topCategory) {

            filters.push(topCategory.title);

        }

    }

    if (chosenCategories.length) {

        filters.push(chosenCategories.map((category) => category.title).join(', '));

    }

    if (regionsStore.chosenRegion) {

        // eslint-disable-next-line
        const region = regionsStore.allRegions.find((region) => region.id === regionsStore.chosenRegion);

        if (region) {

            filters.push(region.name);

        }

    }

    const chosenLocations = locationsStore.selectedLocations;

    if (chosenLocations.length) {

        filters.push(chosenLocations.map((location) => location.name).join(', '));

    }

    // eslint-disable-next-line
    facetsStore.facets.map((facet) => {

        // eslint-disable-next-line
        facet.facetOptions.filter((option) => option.checked).map((option) => {

            filters.push(option.title);

        });

    });

    for (const key in queryParamsStore.params) {

        if (queryParamsStore.params[key] && ['bounds', 'keywords', 'startDate', 'endDate'].includes(key)) {

            if (key === 'bounds') {

                filters.push('Map Search Area');

            } else {

                filters.push(queryParamsStore.params[key]);

            }

        }

    }

    return filters;

});

const clearFilters = function clearFiltersFunc() {

    useClearFilters(
        categoriesStore,
        regionsStore,
        facetsStore,
        queryParamsStore,
        locationsStore,
        datesStore,
    );

};

</script>
